import React from 'react'
import {
  type PredictionRewardProfile,
  type PrizeAllocationRule,
} from './predictionRewardProfile'
import { ALLOCATION_RULE_LABELS } from './predictionRewardLabels'

type Props = {
  rewardProfile?: PredictionRewardProfile | null
  prizeInfo?: {
    headline?: string
    description?: string
    rewardTypes?: string[]
    extraNote?: string
  } | null
}

const REWARD_TYPE_LABELS: Record<string, string> = {
  ODDS: 'โบนัสตาม Odds',
  POINTS_BONUS: 'โบนัสพอยท์',
  PHYSICAL: 'ของรางวัล',
  CUSTOM: 'รางวัลพิเศษ',
}

export default function PredictionRewardInfoCard({ rewardProfile, prizeInfo }: Props) {
  const headline = rewardProfile?.promoHeadline || prizeInfo?.headline
  const description = rewardProfile?.promoDescription || prizeInfo?.description
  const extraNote = rewardProfile?.promoExtraNote || prizeInfo?.extraNote
  const prizes = (rewardProfile?.prizes || []).filter((p) => p.enabled !== false && p.name)

  if (!headline && !description && !prizes.length && !prizeInfo?.rewardTypes?.length) {
    return null
  }

  return (
    <div className="alert alert-success py-2 px-3 mb-3 small">
      <div className="fw-bold mb-1">🎁 รางวัล / สิ่งที่ได้รับ</div>
      {headline && <div className="fw-semibold">{headline}</div>}
      {description && <div className="mb-1" style={{ whiteSpace: 'pre-wrap' }}>{description}</div>}

      {prizeInfo?.rewardTypes && prizeInfo.rewardTypes.length > 0 && (
        <div className="mb-1">
          {prizeInfo.rewardTypes.map((t) => (
            <span key={t} className="badge bg-success me-1">{REWARD_TYPE_LABELS[t] || t}</span>
          ))}
        </div>
      )}

      {prizes.length > 0 && (
        <ul className="mb-1 ps-3">
          {prizes.map((p) => (
            <li key={p.prizeId}>
              <strong>{p.name}</strong>
              {p.quantity > 1 && ` ×${p.quantity}`}
              {' '}
              <span className="text-muted">
                ({ALLOCATION_RULE_LABELS[p.allocationRule as PrizeAllocationRule] || p.allocationRule})
              </span>
              {p.description && <div className="text-muted">{p.description}</div>}
            </li>
          ))}
        </ul>
      )}

      {rewardProfile?.monetaryEnabled && (
        <div className="text-muted">+ จ่ายตาม Odds อัตโนมัติเมื่อทายถูก</div>
      )}
      {extraNote && <div className="text-warning mt-1">* {extraNote}</div>}
    </div>
  )
}
